<template>
  <page
    :custom-style="{ 'padding-top': pagePaddingTopValue }"
    :custom-class="'page-wrapper'"
  >
    <maple-nav-bar
      v-if="showNavBar"
      class="nav-bar"
      left-arrow
      left-arrow-color="#fff"
      background="transprent"
      :style="{
        paddingTop: statusBarHeight + 'px'
      }"
      @click-left="$back"
    >
      <img slot="center" width="80px" src="@/images/seckill/title.png" />
    </maple-nav-bar>
    <scroll-view
      class="seckill-page"
      :reach-bottom-loading="reachBottomLoading"
      :finish="
        (seckillList.length > 0 || promoteList.length > 0) &&
        noMoreSeckillData &&
        noMorePromoteData
      "
      @onScroll="scrollEvent"
      @loadData="loadData"
    >
      <div
        v-if="bannerObject && bannerObject.object_img"
        class="banner"
        @click="toDetail()"
      >
        <img :src="bannerObject.object_img" alt="" />
      </div>
      <div class="sticky-tab-wrapper">
        <tab
          :tab-list="tabList"
          :active-index="activeSeckillIndex"
          :active-tab.sync="activeSeckillTab"
          @set-active-index="setActiveSeckillIndex"
        />
        <class-tab
          :tab-list="classList"
          :active-index="activeClassIndex"
          :is-small="smallClassTab"
          @set-active-index="setActiveClassIndex"
        />
      </div>
      <sku
        v-for="(item, index) in seckillList"
        :key="item.unique_id"
        :good="item"
        :index="index"
        :active-tab="activeSeckillTab"
      />
      <div v-show="promoteList.length > 0" class="promote-title">特惠商品</div>
      <sku
        v-for="(item, index) in promoteList"
        :key="item.unique_id + 'promote'"
        :good="item"
        :index="index"
        :is-promote="true"
      />
      <!-- 缺省展示 -->
      <div v-show="empty" class="empty">
        <img src="@/images/seckill/empty.png" width="40%" />
        <p>暂无商品哦</p>
      </div>
      <cart-float-window />
    </scroll-view>
  </page>
</template>
<script>
import { API } from '@/api'
import { resolveUrlParams, compareTimeInOneDay } from '@/utils/utils'
import { miniProgramEnv } from '@/defines/environment'
import CartFloatWindow from '@/common/widgets/cart_float_window'
import ScrollView from '@/common/widgets/scroll_view'
import Tab from './components/tab'
import classTab from './components/classTab.vue'
import Sku from './components/sku'
export default {
  components: {
    Tab,
    classTab,
    ScrollView,
    Sku,
    CartFloatWindow
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = '限时秒杀'
      // 设置白色状态栏
      vm.$bridge.setLightStatusBar()
    })
  },
  data() {
    return {
      tabList: [], // 秒杀时间段信息
      activeSeckillTab: {}, // 当前正在进行秒杀的tab
      activeSeckillIndex: -1, // 当前正在进行的秒杀tab索引
      classList: [], // 分类tab
      activeClassIndex: 0, // 选中的分类
      smallClassTab: false, // 是否收起分类tab

      seckillList: [], // 秒杀商品列表
      promoteList: [], // 促销商品列表

      seckillPageNum: 1, // 秒杀商品当前页
      promotePageNum: 0, // 促销商品当前页
      pageSize: 20,

      reachBottomLoading: false, // 触底loading
      noMoreSeckillData: false, // 秒杀商品加载结束（拿不到更多的数据了）
      noMorePromoteData: false, // 促销商品加载结束（拿不到更多的数据了）
      bannerObject: {}
    }
  },
  computed: {
    showNavBar() {
      return !miniProgramEnv.isMiniProgram
    },
    pagePaddingTopValue() {
      if (!miniProgramEnv.isMiniProgram) {
        return 44 + this.statusBarHeight + 'px'
      } else {
        return '0px'
      }
    },
    empty() {
      return (
        this.seckillList.length === 0 &&
        this.promoteList.length === 0 &&
        this.noMoreSeckillData &&
        this.noMorePromoteData
      )
    }
  },
  async created() {
    this.scrollEvent = this.debounce(this.onPageScroll, 200)
    try {
      const [seckillInfo, classInfo] = await Promise.all([
        API.cms.getSeckillInfoNew(),
        API.cms.getSecKillClass()
      ])
      this.tabList = seckillInfo?.periodList || []
      const picList = seckillInfo?.picList || []
      this.bannerObject = picList[0] || {}
      this.classList = classInfo || []
      this.checkTime()
    } catch (e) {
      this.$catch(e)
    }
  },
  methods: {
    // 获取当前正在秒杀的时间段
    checkTime() {
      const currentTime = new Date()
      let doSeckillIndex = null // 计算秒杀中的位置
      let firstTomorrowIndex = null // 首个第二天的时段位置
      this.tabList.forEach((item, index) => {
        const startTime = new Date(item.startTime * 1000)
        const endTime = new Date(item.endTime * 1000)

        // 记录首个第二天的时段位置
        if (item.scene_status === 3 && firstTomorrowIndex === 0) {
          firstTomorrowIndex = index + 1
        }

        // 秒杀中
        if (
          item.scene_status !== 3 && // 排除掉第二天的秒杀时段
          !compareTimeInOneDay(currentTime, endTime) &&
          compareTimeInOneDay(currentTime, startTime)
        ) {
          doSeckillIndex = index + 1
        }
      })
      // 秒杀中 -> 第一个 初始标签顺序
      // 没有秒杀中的就取第二天的第一个
      // 由于index会出现0，影响这里判断逻辑，所以上面先+1，最后再-1
      const idx = doSeckillIndex || firstTomorrowIndex || 1
      this.setActiveSeckillIndex(idx - 1)
    },
    // 设置当前正在秒杀索引
    setActiveSeckillIndex(index) {
      if (this.reachBottomLoading) return
      if (this.activeSeckillIndex !== index) {
        // this.exposeSpikeItem()
        this.activeSeckillIndex = index
        this.activeClassIndex = 0
        this.resetData()
        this.getSeckillList()
      }
    },
    // 切换分类
    setActiveClassIndex(index) {
      this.$track(`n.820.668.0`, {
        tab_variety: String(this.classList[index]?.classId || '')
      })
      if (this.reachBottomLoading) return
      if (this.activeClassIndex !== index) {
        this.activeClassIndex = index
        this.resetData()
        this.getSeckillList()
      }
    },
    // 重置数据
    resetData() {
      this.seckillPageNum = 1
      this.promotePageNum = 0
      this.seckillList = []
      this.promoteList = []
      this.noMoreSeckillData = false
      this.noMorePromoteData = false
    },
    debounce(fn, delay) {
      let timeout = null
      return function () {
        const context = this
        const args = arguments
        if (timeout) clearTimeout(timeout)
        timeout = setTimeout(() => {
          fn.apply(context, args)
        }, delay)
      }
    },
    onPageScroll(e) {
      const scrollTop = e?.target?.scrollTop
      if (scrollTop >= 100 && !this.smallClassTab) this.smallClassTab = true
      if (scrollTop < 100 && this.smallClassTab) this.smallClassTab = false
    },
    // 获取秒杀商品数据
    async getSeckillList() {
      const curSeckillTab = this.tabList[this.activeSeckillIndex]
      const curClassTab = this.classList[this.activeClassIndex]
      if (!curSeckillTab || !curClassTab) return

      this.reachBottomLoading = true

      const requestParams = {
        pagenum: this.seckillPageNum,
        pagesize: this.pageSize,
        starttime: curSeckillTab.startTime,
        endtime: curSeckillTab.endTime,
        classId: curClassTab.classId,
        ssu_id: resolveUrlParams().kill_select_ssu || ''
      }

      try {
        const {
          skuList = [],
          isLastPage
        } = await API.cms.getSecKillSkuByTimeRegion(requestParams)

        if (isLastPage === undefined || isLastPage === null) {
          this.noMoreSeckillData = true
          this.reachBottomLoading = false
          return this.loadNext()
        }

        const formatSkuList = this.formatSku(skuList)

        // 设置数据
        if (this.seckillPageNum === 1) {
          this.seckillList = formatSkuList
        } else {
          this.seckillList = this.seckillList.concat(formatSkuList)
        }

        this.noMoreSeckillData = isLastPage === 1

        this.loadNext()
      } catch (e) {
        this.$catch(e)
      }
      this.reachBottomLoading = false
    },
    // 获取促销商品数据
    async getPromoteList() {
      const curSeckillTab = this.tabList[this.activeSeckillIndex]
      const curClassTab = this.classList[this.activeClassIndex]
      if (!curSeckillTab || !curClassTab) return

      this.reachBottomLoading = true

      const requestParams = {
        pagenum: this.promotePageNum,
        pagesize: this.pageSize,
        starttime: curSeckillTab.startTime,
        endtime: curSeckillTab.endTime,
        classId: curClassTab.classId
      }

      try {
        const { skuList = [], isLastPage } = await API.cms.getPromotion(
          requestParams
        )

        if (isLastPage === undefined || isLastPage === null) {
          this.noMorePromoteData = true
          this.reachBottomLoading = false
          return this.$toast('数据异常')
        }

        const formatSkuList = this.formatSku(skuList)

        // 设置数据
        if (this.promotePageNum === 1) {
          this.promoteList = formatSkuList
        } else {
          this.promoteList = this.promoteList.concat(formatSkuList)
        }

        this.noMorePromoteData = isLastPage === 1

        this.loadNext()
      } catch (e) {
        this.$catch(e)
      }
      this.reachBottomLoading = false
    },
    // 处理sku数据
    formatSku(skuList) {
      return skuList.map(sku => {
        sku.SRI = sku.status_remind_info || {}
        // eslint-disable-next-line camelcase
        switch (sku.SRI.goods_status) {
          // 已抢光 || 已售罄
          case 7:
          case 3:
            sku.soldout = true
            break
          // 已参与
          case 8:
            sku.hasParticipate = true
        }
        return sku
      })
    },
    // 当商品数量少于4个时请求下一页，补全页面商品数
    loadNext() {
      if (this.seckillList.length + this.promoteList.length < 10) {
        if (!this.noMoreSeckillData) {
          this.seckillPageNum++
          return this.getSeckillList()
        }
        if (!this.noMorePromoteData) {
          this.promotePageNum++
          return this.getPromoteList()
        }
      }
    },
    // 滚动加载
    loadData() {
      if (this.reachBottomLoading) return
      if (this.noMoreSeckillData && this.noMorePromoteData) return
      if (!this.noMoreSeckillData) {
        this.seckillPageNum++
        return this.getSeckillList()
      } else {
        this.promotePageNum++
        return this.getPromoteList()
      }
    },
    toDetail() {
      // eslint-disable-next-line camelcase
      const { spm, app_url } = this.bannerObject
      if (spm) {
        this.$track(spm)
      }

      // eslint-disable-next-line camelcase
      if (app_url) {
        this.$autoRedirect(app_url)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.seckill-page {
  background-color: #f5f5f5;
}

.sticky-tab-wrapper {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  left: 0;
  z-index: 9;

  background-image: linear-gradient(to right, #ff5454, #ff5423);
}
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: $z-navigation-bar;

  width: 100%;

  background-image: linear-gradient(to right, #ff5454, #ff5423);
}
.banner {
  position: relative;
  z-index: 2;

  width: 100%;
  padding: 0.16rem 0.2rem 0.16rem 0.2rem;

  background-image: linear-gradient(to right, #ff5454, #ff5423);
  img {
    display: block;

    width: 7.1rem;
    height: 1.8rem;

    border-radius: 0.32rem;
  }
}
.promote-title {
  margin: 0.64rem auto 0.24rem;

  font-size: 0.36rem;
  font-weight: 500;
  text-align: center;
}
.empty {
  display: flex;

  padding-top: 50px;

  flex-direction: column;
  align-items: center;

  & > p {
    margin-top: 20px;

    font-size: 0.24rem;
    color: #666;
  }
}
</style>
